export enum SortOrder {
  ASCENDING = "ascending",
  DESCENDING = "descending",
  NONE = "none",
}

export enum SortClass {
  ascend = "ascend",
  descend = "descend",
}

export enum DeviceType {
  desktop = "desktop",
  mobile = "mobile",
}

export enum GuestEmailProductCode {
  WTP = "WTP",
  WSA = "WSA",
  WRMS = "WRMS",
}
